import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/sub-att.svg',
})
export class SubAttComponent {}
